<template>
  <div class='block header-block' :style='wrapperStyles'>
    <div class='block-content-wrapper'>
      <div class="v-wrapper">
        <div class="text" :style='textStyles'>
          <section class='intro' v-html='$t(html, blockTranslationContext + ".options.data")'>
            <p v-html='$t(content.subtitle, "subtitle")'></p>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Utilities from '@/lib/Utilities'
import TranslationMixin from '@/lib/TranslationMixin'
export default {
  props: {
    editable: {type: Boolean, default: false},
    config: {type: Object, default: () => {}},
  },
  mixins: [TranslationMixin],
  created () {
    this.content = this.config
    this.$watch('content', this.onChange, {deep: true})
    this.html = Utilities.editorToHTML(this.content.data)
  },
  data () {
    return {
      content: {}
    }
  },
  components: {

  },
  inject: ['theme', 'blockTranslationContext'],
  computed: {
    wrapperStyles () {
      const backgroundColor = this.content.backgroundColor || 'transparent'
      const backgroundPosition = '50% 50%'
      const backgroundImage = `url(${this.content.image})`
      return {backgroundColor, backgroundImage, backgroundPosition}
    },
    textStyles () {
      let color = this.content.textColor
      let textAlign = this.content.textAlign || 'center'
      let backgroundColor = this.content.boxBackgroundColor || 'transparent'
      return {color, textAlign, backgroundColor}
    }
  },
  methods: {

  }
}
</script>
<style lang='scss'>
  @import '../scss/blocks';
</style>